// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"86d0d9c7","150":"83112927","161":"65b7e3c3","180":"8ab69f8e","196":"5049461c","229":"2c5ea3bb","241":"96e8d17e","262":"c653955f","455":"67d849e3","565":"5049461c","615":"2c5ea3bb","756":"b235b079"}[chunkId] + ".chunk.css";
};